import {verifyMfaCodeAsync} from "../actions/accountActions";
import { createSlice, isAnyOf } from '@reduxjs/toolkit';

type verifyMfaCodePayload = {
    verifyMfa:any,
    mfaverifyloading: boolean,
    message:any
}
const initialState: verifyMfaCodePayload = {
    verifyMfa: [],
    mfaverifyloading: false,
    message:""
}

const VerifyMfaCodeSlice = createSlice({
  name: 'verifyMfaCodeAsync',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(verifyMfaCodeAsync.pending), (state, action) => {
      state.mfaverifyloading = true
            
    })
    builder.addMatcher(isAnyOf(verifyMfaCodeAsync.fulfilled), (state, action) => {
      state.verifyMfa= action?.payload
      state.mfaverifyloading = false
 
    })
    builder.addMatcher(isAnyOf(verifyMfaCodeAsync.rejected), (state,action) => {
      state.mfaverifyloading = false
            state.message= action?.payload
    })
  },
  reducers: {
  },
});

// export const {generateMfaQrCodeAsyncSlice} = generateMfaQrCodeAsyncSlice.actions
export default VerifyMfaCodeSlice.reducer;